import { User } from "../utils/types";
import { generalApiSlice } from "./generalApi";

export interface LoginResponse {
  access: string;
  user: User;
}
export interface LoginRequest {
  email: string;
  password: string;
}

export const authApi = generalApiSlice.injectEndpoints({
  endpoints: (builder) => ({
    register: builder.mutation({
      query: (credentials) => ({
        url: "/auth/register/",
        method: "POST",
        body: credentials,
      }),
      invalidatesTags: ["User"],
    }),
    resendVerificationEmail: builder.mutation({
      query: (email) => ({
        url: "/auth/register/resend-email/",
        method: "POST",
        body: { email },
      }),
      invalidatesTags: ["User"],
    }),
    tokenRefresh: builder.mutation({
      query: (email) => ({
        url: "/auth/register/resend-email/",
        method: "POST",
        body: { email },
      }),
    }),
    passwordReset: builder.mutation({
      query: (data) => ({
        url: "/auth/password/reset/",
        method: "POST",
        body: data,
      }),
    }),
    passwordResetConfirm: builder.mutation({
      query: (data) => ({
        url: "/auth/password/reset/confirm/",
        method: "POST",
        body: data,
      }),
    }),
    verifyEmail: builder.mutation({
      query: (key) => ({
        url: "/auth/register/verify-email/",
        method: "POST",
        body: { key },
      }),
    }),
    login: builder.mutation<LoginResponse, LoginRequest>({
      query: (credentials) => ({
        url: "/auth/login/",
        method: "POST",
        body: credentials,
      }),
      invalidatesTags: ["User"],
    }),
    loginWithGoogle: builder.mutation<LoginResponse, string>({
      query: (accessToken) => ({
        url: "/auth/google/login/",
        method: "POST",
        body: { access_token: accessToken },
      }),
      invalidatesTags: ["User"],
    }),
  }),
});

export const {
  useRegisterMutation,
  useLoginMutation,
  usePasswordResetMutation,
  usePasswordResetConfirmMutation,
  useVerifyEmailMutation,
  useTokenRefreshMutation,
  useLoginWithGoogleMutation,
  useResendVerificationEmailMutation,
} = authApi;
